export default __webpack_public_path__ + "static/media/Search.23a0c651.svg";